// src/components/common/GradientButton.js
// 72차 신규: UNLOCK 디자인 시스템의 골드 그라디언트 CTA 버튼(135deg, #EFD292→#D8AE52).
// React Native는 CSS gradient가 없어 expo-linear-gradient로 구현 — 이 컴포넌트 하나로
// 통일해두면 나중에 그라디언트 각도/색을 한 곳만 고치면 전체 버튼에 반영된다.
// 77차: design 폴더 버튼 시스템(섹션 05) 스펙에 맞춰 비활성 색상을 정확한 값으로 조정
// (#2A2A38/#5A5A68) — 이 컴포넌트가 버튼 시스템의 "1 · Primary"에 해당.
// 78차: 실제 골드 박스는 안쪽 LinearGradient(s.btn)라서, 좁게 만들려고 style에
// paddingVertical 등을 넘겨도 바깥 TouchableOpacity에만 적용되고 안쪽엔 기존
// paddingVertical:14가 그대로 남아 두 패딩이 합쳐져 버튼이 비정상적으로 커지는
// 버그가 있었음(RecruitDetailScreen 댓글/답글 전송, CrewScreen 메시지 전송 등 여러
// 화면에서 반복 발생). style의 padding 계열 값만 골라 안쪽 박스에 적용하도록 수정 —
// 나머지(flex/marginTop 등 레이아웃 값)는 기존처럼 바깥 wrapper에 그대로 적용됨.
// 78차 37차: 선택적 Icon prop 추가(라벨 왼쪽에 아이콘, gap 6) — "예약하기" 버튼의
// 자물쇠 아이콘 프리픽스 요청으로 신규 추가. 기존 호출부는 Icon을 안 넘기면 이전과
// 동일하게 렌더되므로 하위 호환.
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { COLORS, FONTS, GRADIENTS, SHADOW } from '../../constants/theme';

export default function GradientButton({ label, onPress, disabled = false, style, textStyle, Icon }) {
  const flat = StyleSheet.flatten(style) || {};
  const { padding, paddingVertical, paddingHorizontal, ...outerStyle } = flat;
  const innerPadding = {};
  if (padding !== undefined) innerPadding.padding = padding;
  if (paddingVertical !== undefined) innerPadding.paddingVertical = paddingVertical;
  if (paddingHorizontal !== undefined) innerPadding.paddingHorizontal = paddingHorizontal;
  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled}
      activeOpacity={0.85}
      style={[disabled && s.disabledWrap, outerStyle]}
    >
      <LinearGradient
        colors={disabled ? ['#2A2A38', '#2A2A38'] : GRADIENTS.button}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={[s.btn, !disabled && SHADOW.button, innerPadding]}
      >
        <View style={s.row}>
          {Icon ? <Icon size={16} color={disabled ? s.textDisabled.color : COLORS.onGold} /> : null}
          <Text style={[s.text, disabled && s.textDisabled, textStyle]}>{label}</Text>
        </View>
      </LinearGradient>
    </TouchableOpacity>
  );
}

const s = StyleSheet.create({
  btn: {
    borderRadius: 12,
    paddingVertical: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
  row: { flexDirection: 'row', alignItems: 'center', gap: 6 },
  text: {
    color: COLORS.onGold,
    fontSize: 15,
    fontFamily: FONTS.bodyBold,
  },
  // 78차 35차: 디자인 스펙 원본값(#5A5A68)이 배경(#2A2A38)과 명암비가 낮아 실기기에서
  // "비활성화 버튼 글자가 잘 안 보인다"는 신고 — 배경은 스펙 그대로 유지하고 글자만
  // 명암비를 높여 가독성 확보(WCAG AA 4.5:1 근사치로 조정).
  textDisabled: { color: '#8E8E9E' },
  disabledWrap: { opacity: 1 },
});
